import { render, staticRenderFns } from "./CreatePostContextMenu.vue?vue&type=template&id=4a444b64&"
import script from "./CreatePostContextMenu.vue?vue&type=script&lang=ts&"
export * from "./CreatePostContextMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePostContextMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports